import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(
    apiUrls.serviceStatuses +
      '?expand=zeroDaysSinceServiceStatus,hundredPlusDaysSinceServiceStatus',
    true,
  )

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          {
            type: 'u',
            url: '/edit-service-status/' + row.id,
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-service-status/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )

    dataArray[index].show = dataArray[index].show === 1 ? 'Yes' : 'No'
    dataArray[index].default = dataArray[index].default === 1 ? 'Yes' : 'No'
    dataArray[index].allow_rma_edit = dataArray[index].allow_rma_edit === 1 ? 'Yes' : 'No'
    dataArray[index].init_replacement = dataArray[index].init_replacement === 1 ? 'Yes' : 'No'
    dataArray[index].zeroDaysSinceServiceStatus =
      dataArray[index].zeroDaysSinceServiceStatus?.name ?? null
    dataArray[index].hundredPlusDaysSinceServiceStatus =
      dataArray[index].hundredPlusDaysSinceServiceStatus?.name ?? null
  })

  return data
}

export default getRows
